export function formatCurrency(n) {
  return '$' + Math.abs(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function formatNegative(n) {
  return '(' + formatCurrency(Math.abs(n)) + ')';
}

export function formatDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-AU', {
    day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC',
  });
}

export function formatMonthYear(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-AU', {
    month: 'long', year: 'numeric', timeZone: 'UTC',
  });
}

export function formatDateTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return (
    d.toLocaleDateString('en-AU', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' }) +
    ', ' +
    d.toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit', hour12: true, timeZone: 'UTC' })
  );
}

export function groupInvoicesByCreatedAt(invoices) {
  const groups = {};
  const order = [];
  invoices.forEach(inv => {
    const label = formatMonthYear(inv.audit?.createdAt);
    if (!groups[label]) { groups[label] = []; order.push(label); }
    groups[label].push(inv);
  });
  return order.map(label => [label, groups[label]]);
}
